import React, { Component } from "react";
import Modal from "../../../UIComponents/CustomModal/Modal";
import Checkbox from "semantic-ui-react/dist/es/modules/Checkbox";
import "./ImageAnalysticsModal.scss";
import Scrollbars from "react-custom-scrollbars";
import BoundingBoxModal from "./BoundingBoxModal";
import { ReactComponent as PostInfo } from "../../../../assets/svg/info.svg";
import { Button, Popup } from "semantic-ui-react";
class ImageAnalysticsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            defaultCheck: false,
            Logos: Object.keys(this.props.data.Logos) || [],
            Objects: Object.keys(this.props.data.Objects) || [],
            ["Text in Images"]: Object.keys(this.props.data["Text in Images"]) || [],
            Scenes: Object.keys(this.props.data.Scenes) || [],
        };
    }

    checkedSelectAll = (isChecked, data, value) => {
        if (isChecked) {
            this.setState({ [value]: [] });
        } else {
            this.setState({ [value]: Object.keys(data) });
        }
    };

    checkedItems = (item, value) => {
        if (this.state[value].length > 0 && this.state[value].includes(item)) {
            this.setState({ [value]: this.state[value].filter((v) => v !== item) });
        } else {
            this.setState({ [value]: [...this.state[value], item] });
        }
    };

    getImageData = (data, value) => {
        return (
            <div className="popUpDataFields">
                <div className="imageAI-items-fields">
                    {value == "Text in Images" ? (
                        <>
                            <span className="colortheme Ocr"></span>
                            <p> Text in Images </p>
                        </>
                    ) : value == "Objects" ? (
                        <>
                            <span className="colortheme Objects"></span>
                            <p> Objects</p>
                        </>
                    ) : value == "Scenes" ? (
                        <p>Scenes</p>
                    ) : value == "Logos" ? (
                        <>
                            <span className="colortheme Logo"></span>

                            <p>
                                Logos
                                <Popup
                                    trigger={<PostInfo className="post-info" />}
                                    content="Upgrade your package for advanced logo detection capabilities."
                                    inverted
                                    className="image-analytics-modal-popup skiptranslate"
                                    size="mini"
                                    position="right center"
                                />
                            </p>
                        </>
                    ) : (
                        ""
                    )}
                </div>

                <div className="imageAI-items-fields-container">
                    {value == "Scenes" ? (
                        <Scrollbars>
                            <ul>
                                {Object.keys(data).map((rdata_platformValue, index) => (
                                    <li style={{ color: "#1f2e3d" }} key={index}>
                                        {rdata_platformValue}
                                    </li>
                                ))}
                            </ul>
                        </Scrollbars>
                    ) : (
                        <Scrollbars>
                            <Checkbox
                                className="imageAI-items-fields-value"
                                label="Select All"
                                checked={this.state[value].length === Object.keys(data).length}
                                onChange={() => this.checkedSelectAll(this.state[value].length === Object.keys(data).length, data, value)}
                                defaultChecked
                            />
                            {Object.keys(data).map((rdata_platformValue, index) => (
                                <Checkbox
                                    className="imageAI-items-fields-value"
                                    defaultChecked
                                    key={index}
                                    label={rdata_platformValue}
                                    checked={this.state[value].includes(rdata_platformValue)}
                                    onChange={() => this.checkedItems(rdata_platformValue, value)}
                                />
                            ))}
                        </Scrollbars>
                    )}
                </div>
            </div>
        );
    };

    render() {
        return (
            <Modal
                className={`image-info-modal`}
                style={{ height: "70%" }}
                show={this.props.open}
                onClose={() => this.props.hideModal()}
                noSkipGTranslate={true}>
                <Modal.Header>
                    <p className="popUpHeading">Image Analytics Data</p>
                </Modal.Header>
                <Modal.Content className="imagePopUpContainer">
                    <div className="imgContainer" style={{ backgroundImage: `url("${this.props.postImage}")` }}>
                        {" "}
                        {
                            <BoundingBoxModal
                                data={this.props.data}
                                image={this.props.postImage}
                                objects={this.state.Objects}
                                logos={this.state.Logos}
                                ocrText={this.state["Text in Images"]}
                            />
                        }
                    </div>
                    <div className="popUpDataContainer">
                        {Object.keys(this.props.data).length > 0 && this.props.data["Logos"] && Object.keys(this.props.data["Logos"]).length > 0 ? (
                            this.getImageData(this.props.data["Logos"], "Logos")
                        ) : (
                            <div className="popUpDataFields">
                                <div className="imageAI-items-fields" style={{}}>
                                    <span className="colortheme Logo"></span>

                                    <p>
                                        Logos
                                        <Popup
                                            trigger={<PostInfo className="post-info" />}
                                            content="Upgrade your package for advanced logo detection capabilities."
                                            inverted
                                            className="image-analytics-modal-popup skiptranslate"
                                            size="mini"
                                            position="right center"
                                        />
                                    </p>
                                </div>
                                <div className="imageAI-items-fields-container">
                                    <div className="imageAI-items-fields-noValue">
                                        {/* Upgrade your package to enable this functionality */}
                                        No logos detected in this image
                                    </div>
                                </div>
                            </div>
                        )}
                        {Object.keys(this.props.data).length > 0 && this.props.data["Objects"] && Object.keys(this.props.data["Objects"]).length > 0 ? (
                            this.getImageData(this.props.data["Objects"], "Objects")
                        ) : (
                            <div className="popUpDataFields">
                                <div className="imageAI-items-fields" style={{}}>
                                    <span className="colortheme Objects"></span>
                                    <p> Objects</p>
                                </div>
                                <div className="imageAI-items-fields-container">
                                    <div className="imageAI-items-fields-noValue">No objects detected in this image</div>
                                </div>
                            </div>
                        )}

                        {Object.keys(this.props.data).length > 0 &&
                        this.props.data["Text in Images"] &&
                        Object.keys(this.props.data["Text in Images"]).length > 0 ? (
                            this.getImageData(this.props.data["Text in Images"], "Text in Images")
                        ) : (
                            <div className="popUpDataFields">
                                <div className="imageAI-items-fields" style={{}}>
                                    <span className="colortheme Ocr"></span>
                                    <p> Text in Images </p>
                                </div>
                                <div className="imageAI-items-fields-container">
                                    <div className="imageAI-items-fields-noValue">No text detected in this image</div>
                                </div>
                            </div>
                        )}

                        {Object.keys(this.props.data).length > 0 && this.props.data["Scenes"] && Object.keys(this.props.data["Scenes"]).length > 0 ? (
                            this.getImageData(this.props.data["Scenes"], "Scenes")
                        ) : (
                            <div className="popUpDataFields">
                                <div className="imageAI-items-fields" style={{}}>
                                    <p> Scenes</p>
                                </div>
                                <div className="imageAI-items-fields-container">
                                    <div className="imageAI-items-fields-noValue">No scenes detected in this image</div>
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Content>
                <Modal.Content className="ImageModalpostText" noSkipGTranslate={true}>
                    <div className="postText">
                        <div>{this.props.postText}</div>
                    </div>
                </Modal.Content>
            </Modal>
        );
    }
}

export default ImageAnalysticsModal;
